import React, { useCallback, useState } from 'react';
import { ResponsiveScatterPlot } from '@nivo/scatterplot';
import { useSelector } from 'react-redux';
import ReactDOMServer from 'react-dom/server';
import { AppModal } from '@/layout/AppComponents';
import Translator from '../../../../components/helpers/Translator';

const Report31OnlineInfo = (props) => {
  const { responseData } = props;
  const auth = useSelector((state) => state.auth);
  const global = useSelector((state) => state.global);
  const [selectedData, setSelectedData] = useState([]);
  const [showDataModal, setShowDataModal] = useState(false);

  const handleSelectedData = useCallback((data) => {
    let updatedSelectedData = [];

    responseData.onlineInfo.data.map((groupData) => {
      updatedSelectedData = [
        ...updatedSelectedData,
        ...groupData.data.filter(
          (d) =>
            parseFloat(d.x) <= parseFloat(data.data.formattedX) + 0.2 &&
            parseFloat(d.x) >= parseFloat(data.data.formattedX) - 0.2 &&
            parseFloat(d.y) <= parseFloat(data.data.formattedY) + 0.2 &&
            parseFloat(d.y) >= parseFloat(data.data.formattedY) - 0.2
        ),
      ];
    });

    setSelectedData(updatedSelectedData);
    setShowDataModal(true);
  }, []);

  return (
    <div className="row mt-3">
      <div className="col-xl-12">
        <div className="card">
          <div className="card-body">
            <h3 className="wl-title wl-title-color">
              <Translator
                file="module-legalCompliance"
                name="acciona.penalty.risk.penal.obligations"
              />
            </h3>
            <p>
              <Translator
                file="module-intelligence"
                name="module.int.ob-quantity"
                variables={{
                  obligationCount:
                    responseData.onlineInfo.totalObligationsCount,
                }}
                isHtml
              />
            </p>
            <div>
              <div>
                <div
                  style={{
                    minHeight: '800px',
                    height: '50px',
                    width: '100%',
                    position: 'relative',
                  }}
                >
                  <ResponsiveScatterPlot
                    data={responseData.onlineInfo.data}
                    margin={{ top: 60, right: 140, bottom: 70, left: 90 }}
                    xScale={{ type: 'linear', min: 0, max: 5 }}
                    yScale={{ type: 'linear', min: 0, max: 5 }}
                    blendMode="multiply"
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                      orient: 'bottom',
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 0,
                      legend: ReactDOMServer.renderToString(
                        <Translator
                          file="module-legalCompliance"
                          name="acciona.penalty.risk.impact"
                        />
                      ),
                      legendPosition: 'middle',
                      legendOffset: 46,
                    }}
                    axisLeft={{
                      orient: 'left',
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 0,
                      legend: ReactDOMServer.renderToString(
                        <Translator
                          file="module-legalCompliance"
                          name="acciona.penalty.risk.probability"
                        />
                      ),
                      legendPosition: 'middle',
                      legendOffset: -60,
                    }}
                    nodeSize={(node) => parseFloat(node?.data.z)}
                    onClick={(data) => handleSelectedData(data)}
                    tooltip={({ node }) => (
                      <div
                        style={{
                          backgroundColor: '#fff',
                          color: '#333',
                          borderRadius: '2px',
                          padding: '6px 8px',
                          boxShadow: '3px 3px 5px 2px rgba(0,0,0,0.69)',
                        }}
                      >
                        {node?.data?.code ? (
                          <>
                            <b>
                              <Translator
                                file="module-legalCompliance"
                                name="acciona.penalty.risk.code"
                              />
                              :{' '}
                            </b>
                            {node?.data?.code}.{' '}
                          </>
                        ) : (
                          ''
                        )}
                        <b>
                          <Translator
                            file="module-legalCompliance"
                            name="acciona.penalty.risk.impact"
                          />
                          :{' '}
                        </b>
                        {node?.data?.x.toFixed(3)}.{' '}
                        <b>
                          <Translator
                            file="module-legalCompliance"
                            name="acciona.penalty.risk.probability"
                          />
                          :{' '}
                        </b>
                        {node?.data?.y.toFixed(3)}.{' '}
                        <b>
                          <Translator
                            file="module-legalCompliance"
                            name="acciona.penalty.risk.improvement.capacity"
                          />
                          :{' '}
                        </b>
                        {node?.data?.improvementCapacity.toFixed(3)}
                      </div>
                    )}
                  />
                  <AppModal
                    show={showDataModal}
                    size="xl"
                    title={ReactDOMServer.renderToString(
                      <Translator
                        file="module-legalCompliance"
                        name="acciona.penalty.risk.penal.obligations.selected.area"
                      />
                    )}
                    onClose={() => {
                      setShowDataModal(false);
                      setSelectedData([]);
                    }}
                  >
                    {selectedData.length > 0 ? (
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th className="text-center">
                                <Translator
                                  file="module-legalCompliance"
                                  name="acciona.penalty.risk.code"
                                />
                              </th>
                              <th className="text-center">
                                <Translator
                                  file="module-legalCompliance"
                                  name="acciona.penalty.risk.probability"
                                />
                              </th>
                              <th className="text-center">
                                <Translator
                                  file="module-legalCompliance"
                                  name="acciona.penalty.risk.impact"
                                />
                              </th>
                              <th className="text-center">
                                <Translator
                                  file="module-legalCompliance"
                                  name="acciona.penalty.risk.improvement.capacity"
                                />
                              </th>
                              <th className="text-center">
                                <Translator
                                  file="module-legalCompliance"
                                  name="acciona.penalty.risk.residual.priorization"
                                />
                              </th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {selectedData.map((d) => (
                              <tr key={d.id}>
                                <td className="text-center">{d.code}</td>
                                <td className="text-center">{d.x}</td>
                                <td className="text-center">{d.y}</td>
                                <td className="text-center">
                                  {d.improvementCapacity.toFixed(3)}
                                </td>
                                <td className="text-center">
                                  {d.residualPriorization.toFixed(3)}
                                </td>
                                <td className="text-center">
                                  <a
                                    target="_blank"
                                    className="btn btn-xs btn-info"
                                    href={`${global.urlData.rootProject}module/legal-compliance/sp/access-plant-obligation/${auth?.user?.client?.id}/${d.moduleBridgeHex}/${d.plantHex}/${d.hex}/`}
                                    rel="noreferrer"
                                  >
                                    <Translator
                                      file="module-globallegalCompliance"
                                      name="go.to.obligation"
                                    />
                                  </a>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="alert alert-info">
                        <Translator
                          file="module-saicaReports"
                          name="no.results"
                        />
                      </div>
                    )}
                  </AppModal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Report31OnlineInfo;
